import React, { useEffect, useMemo, useState } from 'react';
import styles from './journalHomeBlock.module.scss';
import { sdk } from '../../../../../sdk';
import JournalArticlesSlider from '../../molecules/journal/journalArticlesSlider/JournalArticlesSlider';
import { JournalArticleProps } from '../../templates/journal/journalArticle/JournalArticle';

interface JournalBlockDataProps {
  title?: string;
  numberOfArticles?: number;
  showArrows?: boolean;
  showScrollbar?: boolean;
}

type Article = JournalArticleProps['relatedArticles'];

const JournalBlock: React.FC<JournalBlockDataProps> = ({ title, numberOfArticles, showArrows, showScrollbar }) => {
  const [articles, setArticles] = useState<Article>([]);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const response = await sdk.callAction<{
          items: Article;
        }>({
          actionName: `/contentful/getBlogHomeArticles?limit=${numberOfArticles ?? 8}`,
        });
        if ('data' in response && !response.isError) {
          setArticles(response.data?.items);
        }
      } catch (error) {
        console.error('Error fetching articles:', error);
      }
    };

    fetchArticles();
  }, [numberOfArticles]);

  return useMemo(() => {
    if (!articles?.length) {
      return null;
    }

    return (
      <JournalArticlesSlider
        title={title}
        list={articles}
        showScrollbar={showScrollbar}
        type="homePage"
        customClasses={{
          container: styles.container,
        }}
      />
    );
  }, [articles, showScrollbar, showArrows, title]);
};

export default JournalBlock;
